import './SelectBox.scss'
import locationGray from './../../../assets/icons/location-gray.svg'
import location from './../../../assets/icons/location.svg'

import { useEffect, useState } from 'react'

import ProgressBarFullness from '../ProgressBarFullness'

import { ISelectBox } from '../../../types/MainType'

import { Dropdown } from 'primereact/dropdown'
import { useTranslation } from 'react-i18next'

const SelectBox = (props: {
  selected?: ISelectBox
  placeholder: string
  data: ISelectBox[]
  onClick: (arg0: any) => any
  oneDay: boolean
}) => {
  const { t } = useTranslation()
  const [selectedGroupedCity, setSelectedGroupedCity] = useState<ISelectBox>(props.selected!)
  const places = [
    {
      label: '',
      items: props.data,
    },
  ]

  useEffect(() => {}, [props.selected])

  const onGroupedCityChange = (e: { value: any }) => {
    setSelectedGroupedCity(e.value)
    props.onClick(e.value)
  }

  const selectedCountryTemplate = (option: { name: string }, props: { placeholder: string }) => {
    if (option) {
      return (
        <div className="country-item country-item-value d-flex align-items-center">
          <div className="ms-1 me-2">
            <img alt={option.name} src={locationGray} />
          </div>
          <div className="d-flex flex-column selected-title">
            <label>{props.placeholder}</label>
            <div>{option.name}</div>
          </div>
        </div>
      )
    }

    return (
      <div className="d-flex">
        <img alt="location-gray" src={locationGray} className="ms-1 me-2" />
        <span>{props.placeholder}</span>
      </div>
    )
  }
  const groupedItemTemplate = (option: any) => {
    return (
      <div className="option-row d-flex justify-content-between">
        <div className="option-column d-flex">
          <img alt={option.name} src={location} className="ms-3 me-3" style={{ display: 'none' }} />
          <div className="d-flex flex-column option-item flex-wrap">
            <strong style={{ fontSize: '12px', whiteSpace: 'break-spaces' }}>
              {t('most-used-words.reservation-place')}
            </strong>
          </div>
        </div>
        {props.oneDay && (
          <div className="option-column">
            <div className="d-flex flex-column option-item flex-wrap">
              <strong style={{ fontSize: '12px', whiteSpace: 'break-spaces' }}>{t('dashboard.occupancy')}</strong>
            </div>
          </div>
        )}
      </div>
    )
  }

  const countryOptionTemplate = (option: any) => {
    return (
      <div className="option-row d-flex justify-content-between">
        <div className="option-column d-flex">
          <img alt={option.name} src={locationGray} className="ms-1 me-1 icon" />
          <div className="d-flex flex-column option-item flex-wrap">
            <div className="d-flex flex-wrap">
              <strong style={{ fontSize: '12px', whiteSpace: 'break-spaces' }}>{option.name}</strong>
            </div>
          </div>
        </div>
        {props.oneDay && (
          <div className="option-column">
            <div className="d-flex flex-wrap flex-column">
              <ProgressBarFullness value={option.fullness}></ProgressBarFullness>
              <strong style={{ fontSize: '16px', whiteSpace: 'break-spaces' }}>%{option.fullness}</strong>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="select-box">
      <Dropdown
        panelClassName={'select-box-panel'}
        value={selectedGroupedCity}
        options={places}
        dataKey="id"
        optionLabel="name"
        optionGroupLabel="label"
        optionGroupChildren="items"
        placeholder={props.placeholder}
        onChange={onGroupedCityChange}
        valueTemplate={selectedCountryTemplate}
        itemTemplate={countryOptionTemplate}
        optionGroupTemplate={groupedItemTemplate}
      />
    </div>
  )
}
export default SelectBox
